import React, { useEffect, useState, useMemo } from 'react';
import AuthUser from './AuthUser';
import toast, { Toaster } from "react-hot-toast";
import { useNavigate, useParams } from 'react-router-dom';
import Select from "react-select";

export default function StudentTemplateAdd() {
    const navigate = useNavigate();
    const { id } = useParams();
    const isEdit = !!id;
    const { http, user } = AuthUser();

    const [isLoading, setIsLoading] = useState(false);
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [years, setYears] = useState([]);
    const [standard, setStandard] = useState([]);
    const [devision, setDevision] = useState([]);
    const [location, setLocation] = useState([]);
    const [headReceiptList, setHeadReceiptList] = useState([]);
    const [agent, setAgent] = useState([]);

    const [formData, setFormData] = useState({
        template_name: '',
        ext_10: '',
        adm_date: '',
        gvt_no: '',
        ext_9: '',
        year: '',
        class: '',
        section: '',
        roll_no: '',
        ext_7: '',
        ext_8: '',
        group_name: '',
        dob: '',
        category: '',
        mobile: '',
        religion: '',
        cast: '',
        ext_15: '',
        adhar: '',
        email: '',
        club: '',
        revise_agent_id: '',
        ext_17: '',
        ext_11: '',
        ext_12: '',
        ext_13: '',
        ext_16: '',
        ext_14: '',
        father: '',
        ext_1: '',
        father_occ: '',
        mother: '',
        mother_phone: '',
        mother_occu: '',
        guardian_name: '',
        guardian_relation: '',
        guardian_occu: '',
        guardian_phone: '',
        guardian_address: '',
        ext_4: '',
        ext_5: '',
        pre_school: '',
        tc_num: '',
        head_receipt: '',
        alpha: '',
        reported: 0,
        company_id: user.company_id,
    });

    useEffect(() => {
        http.get(`/year?login_user=${user.id}`).then((res) => setYears(res.data.data || []));
        http.get(`/class?company_id=${user.company_id}`).then((res) => setStandard(res.data.data || []));
        http.get(`/devision?login_user=${user.id}`).then((res) => setDevision(res.data.data || []));
        http.get(`/location?company_id=${user.company_id}`).then((res) => setLocation(res.data.data || []));
        http.get(`/agent?company_id=${user.company_id}`).then((res) => setAgent(res.data.data || []));
        http.get(`/head_generals?company_id=${user.company_id}`).then((res) => {
            if (Array.isArray(res.data.data)) setHeadReceiptList(res.data.data);
        });

        if (isEdit) {
            setIsLoading(true);
            http.get(`/student_template/${id}`).then((res) => {
                const t = res.data.data;
                const updated = { ...formData };
                Object.keys(updated).forEach(key => {
                    if (key === 'company_id') return;
                    if (t[key] !== null && t[key] !== undefined) {
                        updated[key] = t[key];
                    }
                });
                setFormData(updated);
                setIsLoading(false);
            }).catch(() => {
                toast.error("Error loading template");
                setIsLoading(false);
            });
        }
    }, []);

    const handleChange = (e) => {
        const { name, value } = e.target;
        if (name === 'head_receipt') {
            const selected = headReceiptList.find(hr => hr.name === value);
            setFormData({ ...formData, [name]: value, alpha: selected ? selected.alpha || '' : '' });
        } else if (name === 'year') {
            setFormData({ ...formData, [name]: value, class: '' });
        } else if (name === 'revise_agent_id') {
            const selectedAgent = agent.find(a => a.id === parseInt(value));
            setFormData({ ...formData, [name]: value, ext_11: selectedAgent ? selectedAgent.name : '' });
        } else {
            setFormData({ ...formData, [name]: value });
        }
    };

    const classOptions = useMemo(() => {
        if (!formData.year) return [];
        return standard
            .filter((s) => s.ext_3 === formData.year)
            .map((s) => ({ value: s.class_name, label: s.class_name }));
    }, [standard, formData.year]);

    const divisionOptions = useMemo(() => {
        return devision.map((d) => ({ value: d.name, label: d.name }));
    }, [devision]);

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (!formData.template_name.trim()) {
            toast.error("Template Name is required");
            return;
        }
        setIsSubmitting(true);
        try {
            if (isEdit) {
                await http.put(`/student_template_edit/${id}`, formData);
                toast.success("Template updated!");
            } else {
                await http.post('/student_template_add', formData);
                toast.success("Template created!");
            }
            navigate('/student_template_list');
        } catch (error) {
            toast.error(error.response?.data?.message || "Error saving template");
        } finally {
            setIsSubmitting(false);
        }
    };

    if (isLoading) {
        return <div className="text-center py-5"><div className="spinner-border text-primary"></div></div>;
    }

    return (
        <>
            <Toaster />
            <div className="container mt-2">
                <div className="d-flex justify-content-between align-items-center mb-3">
                    <h3>{isEdit ? 'Edit' : 'Add'} Student Template</h3>
                    <button className="btn btn-outline-secondary btn-sm" onClick={() => navigate('/student_template_list')}>
                        <i className="fa fa-arrow-left me-1"></i> Back
                    </button>
                </div>

                <form onSubmit={handleSubmit}>
                    <div className="row mb-3">
                        <div className="col-md-6">
                            <label className="fw-bold">Template Name <span className="text-danger">*</span></label>
                            <input name="template_name" className="form-control" value={formData.template_name}
                                onChange={handleChange} required placeholder="e.g. BSC Nursing 2026-27" />
                        </div>
                    </div>

                    <div className='row'>
                        {/* Personal Details */}
                        <div className='col-md-4 border p-4 mx-1'>
                            <h4>Personal Details</h4>

                            <div className='form-group mt-3'>
                                <label>Student Type</label>
                                <select className="form-control" name="ext_10" value={formData.ext_10} onChange={handleChange}>
                                    <option value="">Select</option>
                                    <option value="New">New</option>
                                    <option value="Old">Old</option>
                                </select>
                            </div>

                            <div className='form-group mt-3'>
                                <label>Admission Date</label>
                                <input name="adm_date" className='form-control' value={formData.adm_date} onChange={handleChange} type='date' />
                            </div>

                            <div className='form-group mt-3'>
                                <label>Gender</label>
                                <select className="form-control" name="ext_9" value={formData.ext_9} onChange={handleChange}>
                                    <option value="">Select Any</option>
                                    <option value="Male">Male</option>
                                    <option value="Fe-Male">Fe-Male</option>
                                </select>
                            </div>

                            <div className='form-group mt-3'>
                                <label>STS Number</label>
                                <input name="gvt_no" className='form-control' value={formData.gvt_no} onChange={handleChange} />
                            </div>

                            <div className='form-group mt-3'>
                                <label>Year</label>
                                <select name="year" className='form-control' value={formData.year} onChange={handleChange}>
                                    <option value="">Select Year</option>
                                    {years.map((y) => (
                                        <option key={y.id} value={y.name}>{y.name}</option>
                                    ))}
                                </select>
                            </div>

                            <div className='form-group mt-3'>
                                <label>Class</label>
                                <Select
                                    options={classOptions}
                                    value={classOptions.find(o => o.value === formData.class)}
                                    onChange={(opt) => setFormData({ ...formData, class: opt ? opt.value : '' })}
                                    isClearable isSearchable
                                    placeholder={formData.year ? "Select Class" : "Select Year first"}
                                    isDisabled={!formData.year}
                                    noOptionsMessage={() => formData.year ? "No classes for this year" : "Select year first"}
                                />
                            </div>

                            <div className='form-group mt-3'>
                                <label>Section</label>
                                <Select
                                    options={divisionOptions}
                                    value={divisionOptions.find(o => o.value === formData.section)}
                                    onChange={(opt) => setFormData({ ...formData, section: opt ? opt.value : '' })}
                                    isClearable isSearchable placeholder="Select Section"
                                    noOptionsMessage={() => "No sections found"}
                                />
                            </div>

                            <div className='form-group mt-3'>
                                <label>Roll No</label>
                                <input name="roll_no" className='form-control' value={formData.roll_no} onChange={handleChange} />
                            </div>

                            <div className='form-group mt-3'>
                                <label>Sibling Name & Class</label>
                                <input name="ext_7" className='form-control' value={formData.ext_7} onChange={handleChange} />
                            </div>

                            <div className='form-group mt-3'>
                                <label>Identity Marks</label>
                                <input name="ext_8" className='form-control' value={formData.ext_8} onChange={handleChange} />
                            </div>

                            <div className='form-group mt-3'>
                                <label>Group Name</label>
                                <input name="group_name" className='form-control' value={formData.group_name} onChange={handleChange} />
                            </div>

                            <div className='form-group mt-3'>
                                <label>Date Of Birth</label>
                                <input name="dob" className='form-control' value={formData.dob} onChange={handleChange} type='date' />
                            </div>

                            <div className='form-group mt-3'>
                                <label>Category</label>
                                <select name="category" className='form-control' value={formData.category} onChange={handleChange}>
                                    <option value="">Select</option>
                                    {['A','B','C','D','E','F','G','H','I','J','K','L','M','N','O','P','Q','R','S','T','U','V','W','X','Y','Z'].map(c => (
                                        <option key={c} value={c}>{c}</option>
                                    ))}
                                </select>
                            </div>

                            <div className='form-group mt-3'>
                                <label>Mobile Number</label>
                                <input name="mobile" className='form-control' value={formData.mobile} onChange={handleChange} />
                            </div>

                            <div className='form-group mt-3'>
                                <label>Religion</label>
                                <input name="religion" className='form-control' value={formData.religion} onChange={handleChange} />
                            </div>

                            <div className='form-group mt-3'>
                                <label>Caste</label>
                                <input name="cast" className='form-control' value={formData.cast} onChange={handleChange} />
                            </div>

                            <div className='form-group mt-3'>
                                <label>Caste Category</label>
                                <input name="ext_15" className='form-control' value={formData.ext_15} onChange={handleChange} />
                            </div>

                            <div className='form-group mt-3'>
                                <label>Aadhaar No/UID</label>
                                <input name="adhar" className='form-control' value={formData.adhar} onChange={handleChange} />
                            </div>

                            <div className='form-group mt-3'>
                                <label>Email</label>
                                <input name="email" className='form-control' value={formData.email} onChange={handleChange} />
                            </div>

                            <div className='form-group mt-3'>
                                <label>Other Remark</label>
                                <input name="club" className='form-control' value={formData.club} onChange={handleChange} />
                            </div>

                            <div className='form-group mt-3'>
                                <label>Revise Agent</label>
                                <select name="revise_agent_id" className='form-control' value={formData.revise_agent_id} onChange={handleChange}>
                                    <option value="">Select any</option>
                                    {agent.map((a) => (
                                        <option key={a.id} value={a.id}>{a.name}</option>
                                    ))}
                                </select>
                            </div>

                            <div className='form-group mt-3'>
                                <label>Agent amount</label>
                                <input name="ext_17" className='form-control' value={formData.ext_17} onChange={handleChange} />
                            </div>

                            <div className='form-group mt-3'>
                                <label>Transport</label>
                                <select className="form-control" name="ext_12" value={formData.ext_12} onChange={handleChange}>
                                    <option value="">Select Any</option>
                                    <option value="Yes">Yes</option>
                                    <option value="No">No</option>
                                </select>
                            </div>

                            {formData.ext_12 !== "No" && formData.ext_12 !== "" && (
                                <>
                                    <div className='form-group mt-3'>
                                        <label>Way</label>
                                        <select className="form-control" name="ext_13" value={formData.ext_13} onChange={handleChange}>
                                            <option value="">Select Any</option>
                                            <option value="One-Way">One Way</option>
                                            <option value="Two-Way">Two Way</option>
                                        </select>
                                    </div>

                                    <div className='form-group mt-3'>
                                        <label>Pickup Location</label>
                                        <select name="ext_16" className='form-control' value={formData.ext_16} onChange={handleChange}>
                                            <option value="">Select any</option>
                                            {location.map((loc) => (
                                                <option key={loc.id} value={loc.name}>{loc.name}</option>
                                            ))}
                                        </select>
                                    </div>
                                </>
                            )}

                            <div className='form-group mt-3'>
                                <label>Previous Class</label>
                                <input name="ext_14" className='form-control' value={formData.ext_14} onChange={handleChange} />
                            </div>
                        </div>

                        {/* Parent / Guardian's Details */}
                        <div className='col-md-4 border p-4 mx-2'>
                            <h4>Parent / Guardian's Details</h4>

                            <div className='form-group mt-3'>
                                <label>Father's Name</label>
                                <input name="father" className='form-control' value={formData.father} onChange={handleChange} />
                            </div>

                            <div className='form-group mt-3'>
                                <label>Father's Phone</label>
                                <input name="ext_1" className='form-control' value={formData.ext_1} onChange={handleChange} />
                            </div>

                            <div className='form-group mt-3'>
                                <label>Father's Occupation</label>
                                <input name="father_occ" className='form-control' value={formData.father_occ} onChange={handleChange} />
                            </div>

                            <div className='form-group mt-3'>
                                <label>Mother's Name</label>
                                <input name="mother" className='form-control' value={formData.mother} onChange={handleChange} />
                            </div>

                            <div className='form-group mt-3'>
                                <label>Mother's Phone</label>
                                <input name="mother_phone" className='form-control' value={formData.mother_phone} onChange={handleChange} />
                            </div>

                            <div className='form-group mt-3'>
                                <label>Mother's Occupation</label>
                                <input name="mother_occu" className='form-control' value={formData.mother_occu} onChange={handleChange} />
                            </div>

                            <div className='form-group mt-3'>
                                <label>Guardian's Name</label>
                                <input name="guardian_name" className='form-control' value={formData.guardian_name} onChange={handleChange} />
                            </div>

                            <div className='form-group mt-3'>
                                <label>Guardian's Relation</label>
                                <input name="guardian_relation" className='form-control' value={formData.guardian_relation} onChange={handleChange} />
                            </div>

                            <div className='form-group mt-3'>
                                <label>Guardian's Occupation</label>
                                <input name="guardian_occu" className='form-control' value={formData.guardian_occu} onChange={handleChange} />
                            </div>

                            <div className='form-group mt-3'>
                                <label>Guardian's Phone</label>
                                <input name="guardian_phone" className='form-control' value={formData.guardian_phone} onChange={handleChange} />
                            </div>

                            <div className='form-group mt-3'>
                                <label>Guardian's Address</label>
                                <textarea name="guardian_address" className='form-control' value={formData.guardian_address} onChange={handleChange}></textarea>
                            </div>
                            <hr />

                            <div className='border border-success p-3'>
                                <div className='form-group mt-3'>
                                    <label>Current Address</label>
                                    <textarea name="ext_4" className='form-control' value={formData.ext_4} onChange={handleChange}></textarea>
                                </div>

                                <div className='form-group mt-3'>
                                    <label>Permanent Address</label>
                                    <textarea name="ext_5" className='form-control' value={formData.ext_5} onChange={handleChange}></textarea>
                                </div>
                            </div>
                        </div>

                        {/* Miscellaneous Details */}
                        <div className='col-md-3 border p-2 px-2'>
                            <h4>Miscellaneous Details</h4>

                            <div className='form-group mt-3'>
                                <label>Previous School Details</label>
                                <textarea name="pre_school" className='form-control' value={formData.pre_school} onChange={handleChange}></textarea>
                            </div>

                            <div className='form-group mt-3'>
                                <label>Head</label>
                                <input name="tc_num" className='form-control' value={formData.tc_num} onChange={handleChange} />
                            </div>

                            <div className='form-group mt-3'>
                                <label>Head Receipt</label>
                                <select name="head_receipt" className='form-control' value={formData.head_receipt} onChange={handleChange}>
                                    <option value="">Select Head Receipt</option>
                                    {headReceiptList.map((r) => (
                                        <option key={r.id} value={r.name}>{r.name}</option>
                                    ))}
                                </select>
                            </div>

                            <div className='form-group mt-3'>
                                <label>Alpha</label>
                                <input name="alpha" className='form-control' value={formData.alpha} onChange={handleChange}
                                    readOnly style={{ backgroundColor: '#e9ecef' }} />
                                <small className="form-text text-muted">Auto-populated from Head Receipt</small>
                            </div>

                            <div className='form-group mt-3'>
                                <label>Reported</label>
                                <select name="reported" className='form-control' value={formData.reported} onChange={handleChange}>
                                    <option value={0}>No</option>
                                    <option value={1}>Yes</option>
                                </select>
                            </div>
                        </div>
                    </div>

                    <div className='col-md-12'>
                        <button className='btn button btn-success mt-3 w-100 mb-3' type="submit" disabled={isSubmitting}>
                            {isSubmitting ? (
                                <><span className="spinner-border spinner-border-sm me-1"></span>Saving...</>
                            ) : (
                                <>{isEdit ? 'Update' : 'Add'} Template</>
                            )}
                        </button>
                    </div>
                </form>
            </div>
        </>
    );
}
